import { Link } from "react-router-dom";

const LOGIN_AREAS = [
  {
    id: "main",
    path: "/login",
    name: "Affidya",
    subtitle: "Gestione struttura",
    mark: "/images/logo.png",
  },
  {
    id: "sanitario",
    path: "/sanitario-login",
    name: "Sanità",
    subtitle: "Sanità Rapida",
    mark: "/images/logo-sanita-mark.png",
  },
  {
    id: "oss",
    path: "/oss-login",
    name: "OSS",
    subtitle: "Area OSS",
    mark: "/images/logo-oss-mark.png",
  },
  {
    id: "autista",
    path: "/autista-login",
    name: "Drive",
    subtitle: "Area Autista",
    mark: "/images/logo-drive-mark.png",
  },
  {
    id: "farmacia",
    path: "/farmacia-login",
    name: "Pharma",
    subtitle: "Portale farmacia",
    mark: "/images/logo-pharma-mark.png",
  },
  {
    id: "immobiliare",
    path: "/portale-immobiliare/login",
    name: "Immobiliare",
    subtitle: "Portale immobiliare",
    mark: "/images/logo-immobiliare-mark.png",
  },
  {
    id: "visite",
    path: "/visite-login",
    name: "Visite",
    subtitle: "Le mie visite",
    mark: "/visite/icons/visite-192.png",
  },
  {
    id: "family",
    path: "/family-login",
    name: "Family",
    subtitle: "Area familiari",
    mark: "/images/logo-family-mark.png",
  },
  {
    id: "work",
    name: "Work",
    subtitle: "In arrivo",
    mark: "/images/logo-work-mark.png",
    comingSoon: true,
  },
];

const THEMES = {
  emerald: {
    title: "text-slate-500",
    link: "border-slate-200 bg-white text-slate-700 hover:border-emerald-200 hover:bg-emerald-50/60 hover:text-emerald-800",
    current: "border-emerald-200 bg-emerald-50 text-emerald-800",
    muted: "text-slate-400",
    soon: "border-slate-200/80 bg-slate-50/80 text-slate-400",
  },
  sky: {
    title: "text-slate-500",
    link: "border-slate-200 bg-white text-slate-700 hover:border-sky-200 hover:bg-sky-50/70 hover:text-sky-800",
    current: "border-sky-200 bg-sky-50 text-sky-800",
    muted: "text-slate-400",
    soon: "border-slate-200/80 bg-slate-50/80 text-slate-400",
  },
  indigo: {
    title: "text-slate-500",
    link: "border-slate-200 bg-white text-slate-700 hover:border-indigo-200 hover:bg-indigo-50/70 hover:text-indigo-800",
    current: "border-indigo-200 bg-indigo-50 text-indigo-800",
    muted: "text-slate-400",
    soon: "border-slate-200/80 bg-slate-50/80 text-slate-400",
  },
  orange: {
    title: "text-slate-500",
    link: "border-slate-200 bg-white text-slate-700 hover:border-orange-200 hover:bg-orange-50/70 hover:text-orange-800",
    current: "border-orange-200 bg-orange-50 text-orange-800",
    muted: "text-slate-400",
    soon: "border-slate-200/80 bg-slate-50/80 text-slate-400",
  },
  teal: {
    title: "text-slate-500",
    link: "border-slate-200 bg-white text-slate-700 hover:border-teal-200 hover:bg-teal-50/70 hover:text-teal-800",
    current: "border-teal-200 bg-teal-50 text-teal-800",
    muted: "text-slate-400",
    soon: "border-slate-200/80 bg-slate-50/80 text-slate-400",
  },
  blue: {
    title: "text-slate-500",
    link: "border-slate-200 bg-white text-slate-700 hover:border-blue-200 hover:bg-blue-50/70 hover:text-blue-800",
    current: "border-blue-200 bg-blue-50 text-blue-800",
    muted: "text-slate-400",
    soon: "border-slate-200/80 bg-slate-50/80 text-slate-400",
  },
  rose: {
    title: "text-slate-500",
    link: "border-slate-200 bg-white text-slate-700 hover:border-rose-200 hover:bg-rose-50/70 hover:text-rose-800",
    current: "border-rose-200 bg-rose-50 text-rose-800",
    muted: "text-slate-400",
    soon: "border-slate-200/80 bg-slate-50/80 text-slate-400",
  },
  violet: {
    title: "text-slate-500",
    link: "border-slate-200 bg-white text-slate-700 hover:border-[#d8ccec] hover:bg-[#f7f5fb] hover:text-[#6e48b5]",
    current: "border-[#d8ccec] bg-[#ede9f6] text-[#5a3b94]",
    muted: "text-slate-400",
    soon: "border-slate-200/80 bg-slate-50/80 text-slate-400",
  },
};

function AreaCopy({ name, subtitle, mutedClass }) {
  return (
    <span className="flex min-h-[2.15rem] min-w-0 flex-col justify-center">
      <span className="block truncate text-[11px] font-extrabold uppercase leading-none tracking-[0.14em]">
        {name}
      </span>
      <span className={`mt-1 block truncate text-[11px] leading-none ${mutedClass}`}>{subtitle}</span>
    </span>
  );
}

function AreaMark({ src }) {
  return <img src={src} alt="" className="h-8 w-8 shrink-0 rounded-[10px] object-contain" />;
}

/**
 * Navigazione tra le aree di login pubbliche.
 * @param {"main"|"sanitario"|"oss"|"autista"|"farmacia"|"immobiliare"} current
 * @param {"emerald"|"sky"|"indigo"|"orange"|"teal"|"blue"|"rose"|"violet"} [theme="emerald"]
 * @param {string} [className]
 */
export default function LoginAreaLinks({ current, theme = "emerald", className = "" }) {
  const styles = THEMES[theme] || THEMES.emerald;

  return (
    <nav className={`w-full ${className}`} aria-label="Altre aree di accesso">
      <p className={`mb-2.5 text-center text-xs font-medium ${styles.title}`}>
        Altre aree di accesso
      </p>
      <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {LOGIN_AREAS.map((area) => {
          const isCurrent = area.id === current;
          const tileClass = "flex min-h-[54px] items-center gap-2.5 rounded-xl border px-3 py-2.5";

          if (area.comingSoon) {
            return (
              <li key={area.id}>
                <div
                  className={`${tileClass} ${styles.soon}`}
                  aria-disabled="true"
                  title="Disponibile a breve"
                >
                  <AreaMark src={area.mark} />
                  <AreaCopy name={area.name} subtitle={area.subtitle} mutedClass={styles.muted} />
                </div>
              </li>
            );
          }

          if (isCurrent) {
            return (
              <li key={area.id}>
                <div className={`${tileClass} ${styles.current}`} aria-current="page">
                  <AreaMark src={area.mark} />
                  <AreaCopy name={area.name} subtitle={area.subtitle} mutedClass={styles.muted} />
                </div>
              </li>
            );
          }

          return (
            <li key={area.id}>
              <Link to={area.path} className={`group ${tileClass} transition ${styles.link}`}>
                <AreaMark src={area.mark} />
                <AreaCopy name={area.name} subtitle={area.subtitle} mutedClass={styles.muted} />
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
